import { API_BASE_URL } from '@synergy/config';
import { PaginatedResponse } from '@synergy/api';
import { createAction } from '@reduxjs/toolkit';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';
import { AppDispatch } from '../../store/store';
import { CustomerApi } from '../api/customer-api';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { enqueueSnackbar } from './snackbar-actions';

const api = new CustomerApi(API_BASE_URL);

export const customersReceived = createAction<PaginatedResponse<AccountListItemDto>>('customer/loaded');

export const fetchCustomers = (searchParams?: URLSearchParams) => async (dispatch: AppDispatch) => {
    const response = await api.getCustomers(searchParams ?? new URLSearchParams());

    if (response.success) {
        dispatch(customersReceived(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};
